import React, { useState, useEffect } from "react";
import Input from "../../../../../core/Inputs/DefaultInput";
import 'react-edit-text/dist/index.css';
import Svg from "../../../../../component/common/Svg";
import VariableSidebar from "../../../../../component/common/layout/VariableSidebar";
import SubHeader from "../../../../../component/common/layout/SubHeader";
import SurveyListSidebar from "../../../../../component/common/layout/SurveyListSidebar";
import SurveyListHeader from "../../../../../component/common/layout/SurveyListHeader";
import { useDispatch, useSelector } from "react-redux";
import { addUtmVariable, deleteUtmVariable, getUtmVariable, updateUtmVariable } from "../../../../../store/actions/variableAction";
import { getTokenData } from "../../../../../store/actions/authAction";
import { useVerifySurveyId } from "../../../../../hooks";
import { Link } from "react-router-dom";
import style from "../../../../style.module.css";
import Card from "../../../../../core/Card";
import NestedMenuToggle from "../../../settings/NestedMenuToggle";
import { useTranslation } from 'react-i18next';

export default function UTMCampaignValues() {
  //==> States <==

  //UTM variable
  const [utmVeriables1, setUtmVeriables1] = useState([]);
  const [utmVeriables2, setUtmVeriables2] = useState([]);
  const [utmVeriables3, setUtmVeriables3] = useState([]);
  const [utmVeriables4, setUtmVeriables4] = useState([]);
  const [counter1, setCounter1] = useState(0);
  const [counter2, setCounter2] = useState(0);
  const [counter3, setCounter3] = useState(0);
  const [counter4, setCounter4] = useState(0);
  const [utm1, setUtm1] = useState('');
  const [utm2, setUtm2] = useState('');
  const [utm3, setUtm3] = useState('');
  const [utm4, setUtm4] = useState('');

  const [utmType, setutmType] = useState('');
  const [utmUpdateVariable, setutmUpdateVariable] = useState('');
  const [utmUpdateVariableId, setutmUpdateVariableId] = useState('');
  const [userId, setuserId] = useState('');
  const [error, setError] = useState('');

  const [currentlyDeletingUTMType, setCurrentlyDeletingUTMType] = useState('VAR');
  const [currentlyDeletingUTMVar, setCurrentlyDeletingUTMVar] = useState(null);
  const [currentlyDeletingUTMField, setCurrentlyDeletingUTMField] = useState(null);


  //Selectors
  const utmVariableData = useSelector((state) => state.variables?.utmVariableData)
  const utmVariableLoading = useSelector((state) => state.variables?.getUtmVariableLoading)
  const { survey_name } = useSelector((state) => state.permissionsData)

  //Other
  const dispatch = useDispatch()
  const survey_id = useVerifySurveyId()
  const { t, i18n } = useTranslation();

  //==> FUNCTIONALITIES <==

  //Data handling
  const clearUtm = () => {
    setUtm1('');
    setUtm2('');
    setUtm3('');
    setUtm4('');
    setutmType('');
    setutmUpdateVariable('');
    setutmUpdateVariableId('');
    setCounter1(0);
    setCounter2(0);
    setCounter3(0);
    setCounter4(0);
    utmVeriables1.length = 0;
    utmVeriables2.length = 0;
    utmVeriables3.length = 0;
    utmVeriables4.length = 0;
  }

  const handleUpdateField = (e, suv_id) => {
    setutmUpdateVariable(e.target.value);
    setutmUpdateVariableId(suv_id);
  }

  const afterUpdateData = () => {
    clearUtm()
  }

  const afterAddData = () => {
    clearUtm()
    fetchVeriables()
  }

  const updateInput = () => {
    const payload = {
      su_var_name: utmUpdateVariable,
      su_suv_id: utmUpdateVariableId,
      survey_id
    }
    setError('')
    dispatch(updateUtmVariable(payload, afterUpdateData, errorCallback))
  }

  const errorCallback = (msg) => {
    setError(msg)
  }

  const handleChange = (e, type) => {
    if (Number(type) === 1) {
      setUtm1(e.target.value);
    }
    if (Number(type) === 2) {
      setUtm2(e.target.value);
    }
    if (Number(type) === 3) {
      setUtm3(e.target.value);
    }
    if (Number(type) === 4) {
      setUtm4(e.target.value);
    }
    setutmType(type);
  }

  const insertInput = () => {
    const payload = {
      su_suv_type: utmType,
      su_var_name: (utmType === 1) ? utm1 : (utmType === 2) ? utm2 : (utmType === 3) ? utm3 : utm4,
      su_added_by: userId,
      su_survey_id: survey_id,
    }
    setError('')
    dispatch(addUtmVariable(payload, afterAddData, errorCallback))
  }

  const addNewField = (counterNumber) => {
    if (counterNumber === 1 && counter1 < 1) {
      setCounter1(counter1 + 1);
    }
    //Second Section 
    if (counterNumber === 2 && counter2 < 1) {
      setCounter2(counter2 + 1);
    }
    //Third Section
    if (counterNumber === 3 && counter3 < 1) {
      setCounter3(counter3 + 1);
    }

    //Fourth Section
    if (counterNumber === 4 && counter4 < 1) {
      setCounter4(counter4 + 1);
    }

  }

  const deleteField = (counterNumber) => {
    if (counterNumber === 1) {
      setCounter1(counter1 - 1);
    }
    if (counterNumber === 2) {
      setCounter2(counter2 - 1);
    }
    if (counterNumber === 3) {
      setCounter3(counter3 - 1);
    }
    if (counterNumber === 4) {
      setCounter4(counter4 - 1);
    }
  }

  const afterDeleteData = () => {
    utmVeriables1.length = 0;
    utmVeriables2.length = 0;
    utmVeriables3.length = 0;
    utmVeriables4.length = 0;
  }

  const handleDeleteVar = (id) => {
    setCurrentlyDeletingUTMField(null)
    setCurrentlyDeletingUTMVar(id)
    setCurrentlyDeletingUTMType('VAR')
  }

  const handleDeleteField = (id) => {
    setCurrentlyDeletingUTMField(id)
    setCurrentlyDeletingUTMVar(null)
    setCurrentlyDeletingUTMType('FIELD')
  }

  const handleCancelPrompt = () => {
    setCurrentlyDeletingUTMField(null)
    setCurrentlyDeletingUTMVar(null)
    setCurrentlyDeletingUTMType('VAR')
  }

  const handleDeletePrompt = (crtType, crtVar, crtField) => {
    if (crtType === 'VAR') {
      deleteVariable(crtVar)
    } else {
      deleteField(crtField)
    }
    handleCancelPrompt()
  }

  const deleteVariable = (value) => {
    dispatch(deleteUtmVariable(value, afterDeleteData))
  }

  const fetchVeriables = () => {
    dispatch(getUtmVariable(survey_id))
  }

  //Effects
  useEffect(() => {
    if (survey_id) {
      fetchVeriables(survey_id);
      clearUtm();
    }
  }, [survey_id]);

  useEffect(() => {
    dispatch(getTokenData(setuserId))
  }, [userId, dispatch])

  useEffect(() => {
    let type1 = [], type2 = [], type3 = [], type4 = []
    utmVariableData.length > 0 && utmVariableData.forEach((variable) => {
      if (variable.su_suv_type === 1) {
        type1 = [...type1, variable]
      }
      if (variable.su_suv_type === 2) {
        type2 = [...type2, variable]
      }
      if (variable.su_suv_type === 3) {
        type3 = [...type3, variable]
      }
      if (variable.su_suv_type === 4) {
        type4 = [...type4, variable]
      }
    })

    setUtmVeriables1(type1)
    setUtmVeriables2(type2)
    setUtmVeriables3(type3)
    setUtmVeriables4(type4)

  }, [utmVariableData])


  return (

    <>
      <div className='d-flex flex-column main-outer-wrapper main-site-wrapper language-page bg-white'>
        <SurveyListHeader />
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <SurveyListSidebar />
          <div id="content" className="flex-grow-1 dashboard-page-outer d-flex flex-column">
            <SubHeader />
            <div className="d-flex variable-pg-wrapper flex-grow-1">
              <VariableSidebar />
              <div className="flex-grow-1 variable-pg-content">
                <div className="survey-main-container">
                  <div className="page-content-wrap variables-main-container p-0">
                    <div className="main-sec-wrap" >
                      <div className="page-heading">
                        {/* breadcrumbs here */}
                        <nav aria-label="breadcrumb">
                          <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/admin/survey/list">{t('survey.title')}</Link></li>
                            <li className="breadcrumb-item"><Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name}</Link></li>
                            <li className="breadcrumb-item"><Link to={`/admin/survey/create/lead-gen-variables?survey_id=${survey_id}`}>{t('survey.variable.heading')}</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><strong>{t('survey.utm.title')}</strong></li>
                          </ol>
                        </nav>
                        {/* breadcrumbs ends here */}
                        <div className="d-flex align-items-start">
                          <div className="mt-2">
                            <NestedMenuToggle />
                          </div>
                          <div className="flex-grow-1 ps-3 ps-lg-0">
                            <h1 className="mb-0 mb-lg-3">{t('survey.utm.title')}</h1>
                            <p>{t('survey.utm.text')}</p>
                          </div>
                        </div>
                      </div>
                      {error && <span className="text-primary">{'UTM variable already exsist with this name.'}</span>}
                      {utmVariableLoading ? <h1 className="loading-text">Loading...</h1> : <div className='row pagesRow varPg'>
                        <div className="col-xxl-3 col-lg-4 col-md-6 mb-3 campaign-full">
                          <div className="campaign-head">{t('survey.utm.source')}</div>
                          <div className="fullcomp">

                            {
                              utmVeriables1.map((utmVeriables1, index) => {
                                return (
                                  <div className="campaign-box" key={index}>
                                    <div className="inputDelete d-flex  align-items-center">
                                      <Input
                                        type="text"
                                        view="outlined"
                                        color="default"
                                        label=""
                                        placeholder=""
                                        value={utmVeriables1.su_var_name}
                                        fill
                                        className={"formsinput"}
                                        onChange={window.modulePermissions.M15.edit == 1 ? (e) => handleUpdateField(e, utmVeriables1.su_suv_id) : undefined}
                                        onBlur={window.modulePermissions.M15.edit == 1 ? updateInput : undefined}
                                        readOnly={window.modulePermissions.M15.edit != 1}
                                      />
                                         {window.modulePermissions.M15.del == 1 && (
                                      <button
                                        type="button"
                                        title='Delete'
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteUTMModal"
                                        className="btn  minusIcon"
                                        value="2"
                                        onClick={() => handleDeleteVar(utmVeriables1.su_suv_id)}
                                      ><Svg name="minus" />
                                      </button>
                                         )}
                                    </div>
                                  </div>
                                )
                              })
                            }

                            {Array.from(Array(counter1)).map((c, index) => {
                              return (
                                <div className="campaign-box" key={index}>
                                  <div className="inputDelete d-flex  align-items-center">
                                    <Input
                                      type="text"
                                      view="outlined"
                                      color="default"
                                      label=""
                                      placeholder=""
                                      name={index}
                                      fill
                                      className={"formsinput"}
                                      value={utm1}
                                      onChange={(e) => handleChange(e, 1)}
                                      onBlur={insertInput}
                                    //onBlur={blurHandler}
                                    />
                                     {window.modulePermissions.M15.del == 1 && (
                                    <button
                                      type="button"
                                      title='Delete'
                                      data-bs-toggle="modal"
                                      data-bs-target="#deleteUTMModal"
                                      className="btn  minusIcon"
                                      value="2"
                                      onClick={() => handleDeleteField(1)}
                                    >
                                      <Svg name="minus" />
                                    </button>
                                     )}
                                  </div>
                                </div>
                              )
                            })}
                            {window.modulePermissions.M15.add == 1 && (<button type="button" className="utmAddBtn btn btn-bordered" onClick={() => addNewField(1)}>{t('survey.utm.add')}</button>)}

                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 mb-3 campaign-full">

                          <div className="campaign-head">{t('survey.utm.medium')}</div>
                          <div className="fullcomp">

                            {
                              utmVeriables2.map((utmVeriables2, index) => {
                                return (
                                  <div className="campaign-box" key={index}>
                                    <div className="inputDelete d-flex  align-items-center">
                                      <Input
                                        type="text"
                                        view="outlined"
                                        color="default"
                                        label=""
                                        placeholder=""
                                        value={utmVeriables2.su_var_name}
                                        // clearButton
                                        fill
                                        className={"formsinput"}
                                        onChange={window.modulePermissions.M15.edit == 1 ? (e) => handleUpdateField(e, utmVeriables2.su_suv_id) : undefined}
                                        onBlur={window.modulePermissions.M15.edit == 1 ? updateInput : undefined}
                                        readOnly={window.modulePermissions.M15.edit != 1}
                                      />
                                       {window.modulePermissions.M15.del == 1 && (
                                      <button
                                        type="button"
                                        title='Delete'
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteUTMModal"
                                        className="btn  minusIcon"
                                        value="2"
                                        onClick={() => handleDeleteVar(utmVeriables2.su_suv_id)}
                                      ><Svg name="minus" /></button>
                                       )}
                                    </div>
                                  </div>
                                )
                              })
                            }
                            {Array.from(Array(counter2)).map((c, index) => {
                              return (
                                <div className="campaign-box" key={index}>
                                  <div className="inputDelete d-flex  align-items-center">
                                    <Input
                                      type="text"
                                      view="outlined"
                                      color="default"
                                      label=""
                                      placeholder=""
                                      name={index}
                                      fill
                                      className={"formsinput"}
                                      value={utm2}
                                      onChange={(e) => handleChange(e, 2)}
                                      onBlur={insertInput}
                                    />
                                     {window.modulePermissions.M15.del == 1 && (
                                    <button
                                      type="button"
                                      title='Delete'
                                      data-bs-toggle="modal"
                                      data-bs-target="#deleteUTMModal"
                                      className="btn  minusIcon"
                                      value="2"
                                      onClick={() => handleDeleteField(2)}
                                    >
                                      <Svg name="minus" />
                                    </button>
                                     )}
                                  </div>
                                </div>
                              )
                            })}
                            {window.modulePermissions.M15.add == 1 && (<button type="button" className="utmAddBtn btn btn-bordered" onClick={() => addNewField(2)}>{t('survey.utm.add')}</button>)}
                          </div>
                        </div>
                        <div className="col-xxl-3 col-lg-4 col-md-6 mb-3 campaign-full">

                          <div className="campaign-head">{t('survey.utm.campaign')}</div>
                          <div className="fullcomp">
                            {
                              utmVeriables3.map((utmVeriables3, index) => {
                                return (
                                  <div className="campaign-box" key={index}>

                                    <div className="inputDelete d-flex  align-items-center">
                                      <Input
                                        type="text"
                                        view="outlined"
                                        color="default"
                                        label=""
                                        placeholder=""
                                        value={utmVeriables3.su_var_name}
                                        // clearButton
                                        fill
                                        className={"formsinput"}
                                        onChange={window.modulePermissions.M15.edit == 1 ? (e) => handleUpdateField(e, utmVeriables3.su_suv_id) : undefined}
                                        onBlur={window.modulePermissions.M15.edit == 1 ? updateInput : undefined}
                                        readOnly={window.modulePermissions.M15.edit != 1}
                                      />
                                       {window.modulePermissions.M15.del == 1 && (
                                      <button
                                        type="button"
                                        title='Delete'
                                        data-bs-toggle="modal"
                                        data-bs-target="#deleteUTMModal"
                                        className="btn  minusIcon"
                                        value="2"
                                        onClick={() => handleDeleteVar(utmVeriables3.su_suv_id)}
                                      ><Svg name="minus" /></button>
                                       )}
                                    </div>
                                  </div>)
                              })
                            }
                            {Array.from(Array(counter3)).map((c, index) => {
                              return (
                                <div className="campaign-box" key={index}>
                                  <div className="inputDelete d-flex  align-items-center">
                                    <Input
                                      type="text"
                                      view="outlined"
                                      color="default"
                                      label=""
                                      placeholder=""
                                      name={index}
                                      fill
                                      className={"formsinput"}
                                      value={utm3}
                                      onChange={(e) => handleChange(e, 3)}
                                      onBlur={insertInput}
                                    />
                                    <button
                                      type="button"
                                      title='Delete'
                                      data-bs-toggle="modal"
                                      data-bs-target="#deleteUTMModal"
                                      className="btn  minusIcon"
                                      value="2"
                                      onClick={() => handleDeleteField(3)}
                                    >
                                      <Svg name="minus" />
                                    </button>
                                  </div>
                                </div>
                              )
                            })}
                            {window.modulePermissions.M15.add == 1 && (<button type="button" className="utmAddBtn btn btn-bordered" onClick={() => addNewField(3)}>{t('survey.utm.add')}</button>)}
                          </div>
                        </div>
                        {/* <div className="col-xxl-3 col-lg-4 col-md-6 mb-3 campaign-full">

                        <div className="campaign-head">UTM campaign variables</div>
                        <div className="fullcomp">
                          {
                            utmVeriables4.map((utmVeriables4) => {
                              return (
                                <div className="campaign-box">
                                  <div className="inputDelete d-flex  align-items-center">
                                    <Input
                                      type="text"
                                      view="outlined"
                                      color="default"
                                      label=""
                                      placeholder=""
                                      value={utmVeriables4.su_var_name}
                                      // clearButton
                                      fill
                                      className={"formsinput"}
                                      onChange={window.modulePermissions.M15.edit == 1 ? (e) => handleUpdateField(e, utmVeriables4.su_suv_id) : undefined}
                                      onBlur={window.modulePermissions.M15.edit == 1 ? updateInput : undefined}
                                      readOnly={window.modulePermissions.M15.edit != 1}
                                    />
                                    {window.modulePermissions.M15.del == 1 && <button type="button" className="btn  minusIcon" value="2" onClick={() => deleteVariable(utmVeriables4.su_suv_id)}><Svg name="minus" /></button>}
                                  </div>
                                </div>
                              )
                            })
                          }
                          {Array.from(Array(counter4)).map((c, index) => {
                            return (
                              <div className="campaign-box">
                                <div className="inputDelete d-flex  align-items-center">
                                  <Input
                                    type="text"
                                    view="outlined"
                                    color="default"
                                    label=""
                                    placeholder=""
                                    name={index}
                                    fill
                                    className={"formsinput"}
                                    value={utm4}
                                    onChange={(e) => handleChange(e, 4)}
                                    onBlur={insertInput}
                                  />
                                  <button type="button" className="btn  minusIcon" value="2" onClick={() => deleteField(4)}><Svg name="minus" /></button>
                                </div>
                              </div>
                            )
                          })}
                          {window.modulePermissions.M15.add == 1 && (<button type="button" className="utmAddBtn btn btn-bordered" onClick={() => addNewField(4)}>+ Add</button>)}
                        </div>
                      </div> */}
                      </div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="customvar-modal modal custom-modal fade deleteModal" id="deleteUTMModal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div className={"formvawrapper delete-modal-wrap modal-sm" + " " + style.wrapper}>
                  <Card view="raised" className={"formstyle p-0" + " " + style.card} >

                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>{t('survey.customFormula.delete')}</h3>
                        <p>{t('survey.utm.text1')} </p>
                      </div>

                      <div className="button-wrap d-flex justify-content-end">
                        <button type="button" className="btn btn-bordered" data-bs-dismiss="modal" onClick={() => handleCancelPrompt()}>{t('survey.customVariable.cancel')}</button>
                        {window.modulePermissions.M15.del == 1 && (<button type="button" className="btn btn-delete ms-3" data-bs-dismiss="modal" onClick={() => handleDeletePrompt(currentlyDeletingUTMType, currentlyDeletingUTMVar, currentlyDeletingUTMField)}>{t('survey.customVariable.confirm_delete')}</button>)}
                      </div>
                    </div>
                  </Card>
                </div >

              </div >
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
